import { CreateCustomerBody } from "../models/bodies/CreateCustomerBody";
import { SaveDesignSnapshotBody } from "../models/bodies/SaveDesignSnapshotBody";
import { UpdateCustomerBody } from "../models/bodies/UpdateCustomerBody";
import { DesignSnapshotResponse } from "../models/responses/DesignSnapshotResponse";
import { StockOrdersConfigDto } from "../models/responses/StockOrdersConfigDto";
import { LogoPriceDto, OrderDto } from "../models/responses/OrderDto";
import { ProfileResponse } from "../models/responses/ProfileResponse";
import { UrlResponse } from "../models/responses/UrlResponse";
import { useAuthorizedFetch } from "./AuthorizedFetch";
import { UpdateDesignBody } from "../models/bodies/UpdateDesignBody";
import { TextLogoResponse } from "../models/responses/TextLogoResponse";
import { CreateTextLogoBody } from "../models/bodies/CreateTextLogoBody";
import { ManufacturerDto } from "../models/responses/ManufacturerDto";
import { DesignSummaryResponse } from "../models/responses/DesignSummaryResponse";
import { CreateManufacturerBody } from "../models/bodies/CreateManufacturerBody";
import { CreateUserBody } from "../models/bodies/CreateUserBody";
import {
  SetUserHidePricesBody,
  UpdateUserBody,
} from "../models/bodies/UpdateUserBody";
import { CreateMaskQueueCount } from "../models/responses/CreateMaskQueueCount";
import { UpdateStyleBody } from "../models/bodies/UpdateStyleBody";
import { PageQuery, toQueryParam } from "../../utils/models/pageQuery";
import { getActAsOrgId } from "../../contexts/actAsStore";
import { BaseLogo, ImageLogo, getLogoOrgId } from "../../core/models/entities/BaseLogo";
import { Organization } from "../../core/models/entities/Organization";
import { enviroment } from "../../enviroment";
import { CreateDesignDto } from "../../core/models/dtos/CreateDesignDto";
import { DesignDto } from "../models/responses/DesignDto";
import { PagedResponse } from "../models/responses/pagedResponse";
import { LogoDto, LogoStorageCountByOrgDto } from "../models/responses/LogoDto";
import { OrganizationDto } from "../models/responses/OrganizationDto";
import { PlaceOrderQueueItemDto } from "../models/responses/PlaceOrderQueueItemDto";
import { UpdateProfileDto } from "../../core/models/entities/UpdateProfileDto";
import { StyleDto } from "../models/responses/StyleDto";
import { ApprovalSubmission } from "../models/bodies/ApprovalSubmission";
import { LogoOptionsDto } from "../models/responses/logoOptionsDto";
import { TransferDto } from "../models/responses/transferOptionsDto";
import {
  ChangeLogoColors,
  InitiateApproval,
} from "../../presentation/screens/logo-list/hooks/useLogoActionsHandler";
import { LogoCommit } from "../models/bodies/LogoCommit";
import { Design } from "../../core/models/entities/Design";
import { User } from "../../core/models/entities/User";
import { CommissionProfile } from "../../core/models/entities/Commission";
import { CommissionProfileDto } from "../models/responses/CommissionDto";
import {
  CreateOrderDto,
  CreateOrderPreferencesDto,
  UpdateOrderDto,
} from "../../core/models/dtos/CreateOrderDto";
import {
  DeliveryType,
  Order,
  OrderLineDesign,
  Packaging,
} from "../../core/models/entities/Order";
import { Verdict } from "../../presentation/components/ApprovalVoting/approval-voting";
import { CountryDto } from "../models/responses/CountryDto";
import { CbsConfigDto } from "../models/responses/cbsConfigDto";
import { CreateImageLogoBody } from "../models/bodies/CreateImageLogoBody";
import {
  CartItemDesign,
  CartItemDesignInstance,
  CartSummary,
  CartSummaryRequest,
} from "../../presentation/screens/order-create/models/CartItem";
import { CreateDesignTemplateDto } from "../../core/models/dtos/CreateDesignTemplateDto";
import { CreateNameLogoBody } from "../models/bodies/CreateNameLogoBody";
import { CreateNumberLogoBody } from "../models/bodies/CreateNumberLogoBody";
import { ChangeStyleBody, ChangeTitleBody } from "../models/bodies/ChangeBody";
import {
  DesignTemplate,
  LogoTemplate,
} from "../../core/models/entities/DesignTemplate";
import { ExcludedEmailDomainDto } from "../models/responses/ExcludedEmailDomainDto";
import { AddExcludedEmailDomainDto } from "../models/bodies/AddExcludedEmailDomainDto";
import { DeleteExcludedEmailDomainDto } from "../models/bodies/DeleteExcludedEmailDomainDto";
import { OrganizationManufacturerAccessDto } from "../models/responses/OrganizationManufacturerAccessDto";
import {
  StartPriceImportRequestDto,
  StartPriceImportResponseDto,
  PriceImportStatusResponseDto,
  PriceImportHistoryResponseDto,
  CancelPriceImportResponseDto,
} from "../models/responses/PriceImportDto";
import {
  BulkLogoImportRequestDto,
  BulkLogoImportResponseDto,
  LogoSerialsResponseDto,
  LogoSerialsFilterParams,
} from "../models/responses/LogoImportDto";
import {
  BulkDesignImportRequestDto,
  BulkDesignImportResponseDto,
  DesignSerialsResponseDto,
  DesignSerialsFilterParams,
} from "../models/responses/DesignImportDto";
import {
  StatisticsOverviewDto,
  TopVendorDto,
  TopVendorMetric,
  ConversionMetricsDto,
  ApprovalMetricsDto,
  GoogleAnalyticsReportDto,
  GoogleAnalyticsReportType,
  OrdersTodayDto,
} from "../models/responses/StatisticsResponses";
import { PrepaymentVendorDto } from "../models/responses/PrepaymentVendorDto";
import { BillingOverviewDto } from "../models/responses/BillingOverviewDto";
import { BillingVendorGroupDto } from "../models/responses/BillingVendorGroupDto";
import { VendorUserDto } from "../models/responses/VendorUserDto";
import { PrepaymentStatusDto } from "../models/responses/PrepaymentStatusDto";
import { PlaceOrderAckDto } from "../models/responses/PlaceOrderAckDto";
import {
  ImportFailureDto,
  QueueLogoImportResponse,
} from "../models/responses/ImportFailureDto";
import { SystemHealthDto } from "../models/responses/SystemHealthDto";
import { DesignFolderDto } from "../models/responses/DesignFolderDto";
import { WhatsNewResponse } from "../models/responses/WhatsNewDto";
import {
  CreateDesignFolderBody,
  UpdateDesignFolderBody,
  MoveDesignFolderBody,
  ReorderDesignFoldersBody,
  MoveDesignsToFolderBody,
  MoveLogosToFolderBody,
} from "../models/bodies/DesignFolderBodies";
import {
  CreateSharingRelationBody,
  LogoSharingInfoDto,
  OrganizationSharingDto,
  SharingChainShopDto,
  SharingRelationDto,
  SharingSelectionsDto,
  UpdateSharingRelationBody,
} from "../models/responses/LogoSharingDto";

// Act-as-vendor scoping for the JWT-scoped LIST endpoints (orders, logos,
// designs and the order badges): the act-as state is client-side only, so an
// admin's token would otherwise make the API's admin branch return EVERY
// org's rows (bug B: "Sport 24 Business Silkeborg" seeing all Jetsport test
// orders; also the DKK/EUR row mix on the logo/design lists). Appending
// actAsOrgId lets the API (admin-only, validated server-side) narrow to the
// vendor's own scope. For non-impersonating sessions getActAsOrgId() is
// undefined and the URL is unchanged. Applied here at the single choke point
// so every caller (screens, prefetch waves, useHasChainLogos, order-by-number
// polling) is scoped identically.
function withActAsOrgId(queryString: string): string {
  const actAsOrgId = getActAsOrgId();
  if (actAsOrgId === undefined) return queryString;
  return `${queryString}${queryString.includes("?") ? "&" : "?"}actAsOrgId=${actAsOrgId}`;
}

// FIXME: Should use current user's organization id instead of the selected customer's id
// FIXME: Please find the above comment attached multiple places in the code below.
//  The problem is general and should be fixed across API calls where relevant.
//  Please ask with backend dev for exact requirements before changing anything.
export function useApiClient() {
  const API_URL = enviroment.apiUrl;

  const { authFetch } = useAuthorizedFetch();

  async function getAllStyles(
    query: PageQuery,
  ): Promise<PagedResponse<StyleDto>> {
    const queryString = toQueryParam(query);
    const response = await authFetch(`${API_URL}/styles${queryString}`);

    return await response.json();
  }

  async function getAllDesigns(
    query: PageQuery,
    includePrices: boolean = true,
    signal?: AbortSignal,
  ): Promise<PagedResponse<DesignDto>> {
    // toQueryParam always emits at least pageSize/pageIndex here, so the
    // string starts with "?" and the &includePrices append stays valid.
    const queryString = withActAsOrgId(toQueryParam(query));
    const includePricesParam = `${queryString.includes("?") ? "&" : "?"}includePrices=${includePrices}`;
    const response = await authFetch(
      `${API_URL}/organizations/designs${queryString}${includePricesParam}`,
      { signal },
    );
    return await response.json();
  }

  // --- Design folders (see DesignFolderRepository) ---

  async function getDesignFolders(orgId: number): Promise<DesignFolderDto[]> {
    const response = await authFetch(`${API_URL}/organizations/${orgId}/folders`);
    return await response.json();
  }

  async function createDesignFolder(
    orgId: number,
    body: CreateDesignFolderBody,
  ): Promise<DesignFolderDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/folders`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
    return await response.json();
  }

  async function updateDesignFolder(
    orgId: number,
    folderId: number,
    body: UpdateDesignFolderBody,
  ): Promise<void> {
    await authFetch(`${API_URL}/organizations/${orgId}/folders/${folderId}`, {
      method: "PUT",
      body: JSON.stringify(body),
    });
  }

  // Backend answers 409/400 when the folder is not empty.
  async function deleteDesignFolder(
    orgId: number,
    folderId: number,
  ): Promise<void> {
    await authFetch(`${API_URL}/organizations/${orgId}/folders/${folderId}`, {
      method: "DELETE",
    });
  }

  // Re-parent a folder (parentId null = top level). The FolderBar guards
  // against self/descendant targets before calling; the backend validates too.
  async function moveDesignFolder(
    orgId: number,
    folderId: number,
    body: MoveDesignFolderBody,
  ): Promise<void> {
    await authFetch(
      `${API_URL}/organizations/${orgId}/folders/${folderId}/move`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  }

  // Full new sibling order for one level (parentId null = top level).
  async function reorderDesignFolders(
    orgId: number,
    body: ReorderDesignFoldersBody,
  ): Promise<void> {
    await authFetch(`${API_URL}/organizations/${orgId}/folders/reorder`, {
      method: "PUT",
      body: JSON.stringify(body),
    });
  }

  async function moveDesignsToFolder(
    orgId: number,
    body: MoveDesignsToFolderBody,
  ): Promise<void> {
    await authFetch(`${API_URL}/organizations/${orgId}/designs/folder`, {
      method: "PUT",
      body: JSON.stringify(body),
    });
  }

  async function moveLogosToFolder(
    orgId: number,
    body: MoveLogosToFolderBody,
  ): Promise<void> {
    await authFetch(`${API_URL}/organizations/${orgId}/logos/folder`, {
      method: "PUT",
      body: JSON.stringify(body),
    });
  }

  // --- What's new changelog (see ContentRepository) ---

  // Entries arrive sorted newest first (pinned API contract).
  async function getWhatsNew(): Promise<WhatsNewResponse> {
    const response = await authFetch(`${API_URL}/content/whats-new`);
    return await response.json();
  }

  async function getPendingOrdersCount(): Promise<{ count: number }> {
    const response = await authFetch(
      `${API_URL}/organizations/orders/pending-count${withActAsOrgId("")}`,
    );
    return await response.json();
  }

  // Stripe prepayment: the vendor's outstanding "Awaiting payment" orders,
  // grouped by currency (children can bill in another currency).
  async function getAwaitingPaymentSummary(): Promise<{
    count: number;
    byCurrency: { currency: string; count: number; total: number }[];
  }> {
    const response = await authFetch(
      `${API_URL}/organizations/orders/awaiting-payment-summary${withActAsOrgId("")}`,
    );
    return await response.json();
  }

  async function getAllOrders(
    query: PageQuery,
  ): Promise<PagedResponse<OrderDto>> {
    const response = await authFetch(
      `${API_URL}/organizations/orders${withActAsOrgId(toQueryParam(query))}`,
    );
    return await response.json();
  }

  async function getAllManufacturers(
    orgId?: number,
  ): Promise<PagedResponse<ManufacturerDto>> {
    let orgIdQuery = "";

    if (orgId) {
      orgIdQuery = `orgId=${orgId}&`;
    }

    const response = await authFetch(
      `${API_URL}/manufacturers?${orgIdQuery}pageSize=0`,
    );
    return await response.json();
  }

  async function getManufacturer(
    manufacturerId: number,
  ): Promise<ManufacturerDto> {
    const response = await authFetch(
      `${API_URL}/manufacturers/${manufacturerId}`,
    );
    return await response.json();
  }

  async function getDesign(
    organizationId: number,
    designId: number,
  ): Promise<DesignDto> {
    // Act-as: same treatment as getLogo (#603). The path orgId is the
    // design's/customer's own org (access path, unchanged); actAsOrgId makes
    // the API map the detail in the impersonated vendor's context (per-org
    // number-logo storage counts) — design PRICES are vendor-of-the-design
    // driven server-side and identical either way. No-op outside act-as.
    const response = await authFetch(
      `${API_URL}/organizations/${organizationId}/designs/${designId}${withActAsOrgId("")}`,
    );
    return await response.json();
  }

  async function createDesign(body: CreateDesignDto): Promise<DesignDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${body.orgId}/designs`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
    return await response.json();
  }

  async function updateDesign(
    organizationId: number,
    designId: number,
    body: UpdateDesignBody,
  ): Promise<DesignDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${organizationId}/designs/${designId}`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
    return await response.json();
  }

  async function createImageLogo(body: CreateImageLogoBody): Promise<LogoDto> {
    const response = await authFetch(`${API_URL}/organizations/image-logo`, {
      method: "POST",
      body: JSON.stringify(body),
    });

    return response.json();
  }

  async function uploadFileImageLogo(
    logo: File,
    customerId: number,
    logoId: number,
  ): Promise<LogoDto> {
    const formData = new FormData();
    formData.append("file", logo);

    const response = await authFetch(
      `${API_URL}/organizations/${customerId}/image-logo/${logoId}`,
      {
        method: "PUT",
        body: formData,
      },
    );

    return response.json();
  }

  async function createAndUploadImageLogo(
    logo: File,
    orgId: number,
  ): Promise<LogoDto> {
    const formData = new FormData();
    formData.append("file", logo);

    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/image-logo`,
      {
        method: "POST",
        body: formData,
      },
    );

    return response.json();
  }

  async function createOrder(
    orgId: number,
    createOrder: CreateOrderDto,
  ): Promise<OrderDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/orders`,
      {
        method: "POST",
        body: JSON.stringify(createOrder),
      },
    );

    return await response.json();
  }

  async function updateOrder(
    orgId: number,
    orderId: number,
    updateOrder: UpdateOrderDto,
  ): Promise<OrderDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/orders/${orderId}`,
      {
        method: "PUT",
        body: JSON.stringify(updateOrder),
      },
    );

    return response.json();
  }

  async function getOrderPrices(
    orgId: number | undefined,
    createOrder: CreateOrderDto,
  ): Promise<LogoPriceDto[]> {
    if (orgId === undefined) {
      return [];
    }

    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/orderprices`,
      {
        method: "POST",
        body: JSON.stringify(createOrder),
      },
    );

    return response.json();
  }

  async function commitOrder(
    orgId: number,
    orderId: number,
    createOrder: CreateOrderPreferencesDto,
  ): Promise<OrderDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/orders/${orderId}/commit`,
      {
        method: "POST",
        body: JSON.stringify(createOrder),
      },
    );

    return response.json();
  }

  async function placeOrder(
    orgId: number,
    createOrder: CreateOrderPreferencesDto,
  ): Promise<PlaceOrderAckDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/orders/place`,
      {
        method: "POST",
        body: JSON.stringify(createOrder),
      },
    );

    return response.json();
  }

  async function summarizeOrder(
    orgId: number,
    body: CartSummaryRequest,
  ): Promise<CartSummary> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/orders/prices`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );

    return response.json();
  }

  async function createTextLogo(
    orgId: number,
    body: CreateTextLogoBody,
  ): Promise<LogoDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/text-logo`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
    return response.json();
  }

  async function createPlaceholderNameLogo(
    orgId: number,
    body: CreateNameLogoBody,
  ): Promise<LogoDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/name-logo?orgId=${orgId}`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
    return response.json();
  }

  async function createPlaceholderNumberLogo(
    orgId: number,
    body: CreateNumberLogoBody,
  ): Promise<LogoDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/number-logo?orgId=${orgId}`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
    return response.json();
  }

  async function generateTextLogoPreview(
    orgId: number,
    body: CreateTextLogoBody,
  ): Promise<string> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/text-logo-preview`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );

    return await response.text();
  }

  async function generateNumberLogoPreview(
    orgId: number,
    body: CreateNumberLogoBody,
  ): Promise<string> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/number-logo-preview?orgId=${orgId}`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );

    return await response.text();
  }

  async function updateLogo(orgId: number, logo: BaseLogo): Promise<BaseLogo> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/logos/${logo.id}/update`,
      {
        method: "PUT",
        body: JSON.stringify(logo),
      },
    );

    return response.json();
  }

  async function resizeLogo(orgId: number, logo: BaseLogo): Promise<BaseLogo> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/logos/${logo.id}/resize`,
      {
        method: "PUT",
        body: JSON.stringify(logo),
      },
    );

    return response.json();
  }

  async function copyLogo(orgId: number, logoId: number): Promise<BaseLogo> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/logos/${logoId}/copy`,
      {
        method: "POST",
      },
    );

    return response.json();
  }

  async function commitLogo(
    logo: BaseLogo,
    logoCommit: LogoCommit,
  ): Promise<BaseLogo> {
    const logoId = logo.id;
    const orgId = getLogoOrgId(logo);

    const url = `${API_URL}/organizations/${orgId}/logos/${logoId}/commit`;

    const response = await authFetch(url, {
      method: "PUT",
      body: JSON.stringify(logoCommit),
    });

    return response.json();
  }

  async function commitDesign(design: Design): Promise<DesignDto> {
    const designId = design.id;
    const orgId = design.customer.id;

    const url = `${API_URL}/organizations/${orgId}/designs/${designId}/commit`;

    const response = await authFetch(url, {
      method: "PUT",
    });

    return response.json();
  }

  async function skipApprovalDesign(design: Design): Promise<DesignDto> {
    const designId = design.id;
    const orgId = design.customer.id;

    const url = `${API_URL}/organizations/${orgId}/designs/${designId}/approval-skip`;

    const response = await authFetch(url, {
      method: "POST",
    });

    return response.json();
  }

  async function copyDesign(
    orgId: number,
    designId: number,
  ): Promise<DesignDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/designs/${designId}/copy`,
      {
        method: "POST",
      },
    );

    return response.json();
  }

  async function getAllTextLogos(): Promise<TextLogoResponse[]> {
    return [];
  }

  async function getDesignSnapshot(
    organizationId: number,
    designId: number,
  ): Promise<DesignSnapshotResponse> {
    const response = await authFetch(
      `${API_URL}/organizations/${organizationId}/designs/${designId}/snapshot`,
    );
    return await response.json();
  }

  async function getDesignPriceSummary(
    organizationId: number,
    designId: number,
  ): Promise<DesignSummaryResponse> {
    const response = await authFetch(
      `${API_URL}/organizations/${organizationId}/designs/${designId}/summary`,
    );
    return await response.json();
  }

  async function getOrder(
    organizationId: number,
    orderId: number,
    lightweight?: boolean,
  ): Promise<OrderDto> {
    const url = lightweight
      ? `${API_URL}/organizations/${organizationId}/orders/${orderId}?lightweight=true`
      : `${API_URL}/organizations/${organizationId}/orders/${orderId}`;
    const response = await authFetch(url);

    return await response.json();
  }

  async function saveDesignSnapshot(
    organizationId: number,
    designId: number,
    body: SaveDesignSnapshotBody,
  ): Promise<void> {
    await authFetch(
      `${API_URL}/organizations/${organizationId}/designs/${designId}/snapshot`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  }

  async function submitDesign(
    organizationId: number,
    designId: number,
    submission: ApprovalSubmission,
  ): Promise<void> {
    await authFetch(
      `${API_URL}/organizations/${organizationId}/designs/${designId}/submit`,
      {
        method: "PUT",
        body: JSON.stringify(submission),
      },
    );
  }

  async function getVendor(id: number): Promise<OrganizationDto> {
    const response = await authFetch(`${API_URL}/organizations/vendor/${id}`);
    return await response.json();
  }

  async function getOrganization(id: number): Promise<OrganizationDto> {
    if (id == null || id === 0) {
      throw new Error("Invalid organization ID");
    }
    const response = await authFetch(`${API_URL}/organizations/${id}`);
    return await response.json();
  }

  async function getCustomer(id: number): Promise<OrganizationDto> {
    const response = await authFetch(`${API_URL}/organizations/customer/${id}`);
    return await response.json();
  }

  async function getAllVendors(
    query: PageQuery,
  ): Promise<PagedResponse<OrganizationDto>> {
    const queryString = toQueryParam(query);
    const response = await authFetch(
      `${API_URL}/organizations/Vendors${queryString}`,
    );
    return await response.json();
  }

  async function getAllCustomers(
    query: PageQuery,
  ): Promise<PagedResponse<OrganizationDto>> {
    const queryString = toQueryParam(query);
    const response = await authFetch(
      `${API_URL}/organizations/Customers${queryString}`,
    );
    return await response.json();
  }

  async function createOrganization(
    body: CreateCustomerBody,
  ): Promise<OrganizationDto> {
    const response = await authFetch(`${API_URL}/organizations`, {
      method: "POST",
      body: JSON.stringify(body),
    });

    return await response.json();
  }

  async function updateOrganization(
    customerId: number,
    body: UpdateCustomerBody,
  ): Promise<OrganizationDto> {
    const response = await authFetch(`${API_URL}/organizations/${customerId}`, {
      body: JSON.stringify(body),
      method: "PUT",
    });

    return await response.json();
  }

  async function deleteOrganization(id: number): Promise<void> {
    await authFetch(`${API_URL}/organizations/${id}`, {
      method: "DELETE",
    });
  }

  async function createCustomer(
    customer: Organization,
  ): Promise<OrganizationDto> {
    const response = await authFetch(`${API_URL}/organizations/customers`, {
      method: "POST",
      body: JSON.stringify(customer),
    });

    return await response.json();
  }

  async function updateCustomer(
    customer: Organization,
  ): Promise<OrganizationDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${customer.id}`,
      {
        body: JSON.stringify(customer),
        method: "PUT",
      },
    );

    return await response.json();
  }

  async function deleteCustomer(customer: Organization): Promise<void> {
    await authFetch(`${API_URL}/organizations/${customer.id}`, {
      method: "DELETE",
    });
  }

  async function getLogos(
    orgId: number,
    query: PageQuery,
  ): Promise<PagedResponse<LogoDto>> {
    const queryString = toQueryParam(query);
    const response = await authFetch(`${API_URL}/logos/data`);

    return await response.json();
  }

  async function getAllLogos(
    query: PageQuery,
    type?: string,
    signal?: AbortSignal,
  ): Promise<PagedResponse<LogoDto>> {
    const typeParameter = type ? "/" + type : "";
    const queryString = withActAsOrgId(toQueryParam(query));
    const response = await authFetch(
      `${API_URL}/logos${typeParameter}${queryString}`,
      { signal },
    );
    const data = await response.json();
    return data;
  }

  // CSV export of global (stock) logos. Returns the raw Response - the body
  // is text/csv (not JSON), so the caller streams it into a Blob download.
  // Admin-only server-side (Role.Admin via WithUserAccess); the FE only shows
  // the button for admins.
  async function exportGlobalLogosCsv(): Promise<Response> {
    return await authFetch(`${API_URL}/logos/export/csv?isForAllCustomers=true`);
  }

  async function getAllLogosForDesign(
    customerId: number,
    query: PageQuery,
  ): Promise<PagedResponse<LogoDto>> {
    const queryString = toQueryParam(query);
    const response = await authFetch(
      `${API_URL}/logos/design/${customerId}${queryString}`,
    );
    return await response.json();
  }

  async function getAllCountries(
    query: PageQuery,
  ): Promise<PagedResponse<CountryDto>> {
    const queryString = toQueryParam(query);
    const response = await authFetch(`${API_URL}/countries${queryString}`);
    return await response.json();
  }

  async function getCbsConfig(): Promise<CbsConfigDto[]> {
    const response = await authFetch(`${API_URL}/cbs-config`);
    return await response.json();
  }

  async function getLogo(orgId: number, logoId: number): Promise<LogoDto> {
    // Act-as: the path orgId is getLogoOrgId(logo) = the LOGO's own org (access
    // path, unchanged). Without actAsOrgId the API's admin branch prices the
    // detail against that org — for shared logos a FOREIGN org's currency — so
    // the popup/cart showed DKK amounts while the act-as list showed EUR.
    // With the param the API prices against the impersonated vendor (same fix
    // as the #762 list endpoints). No-op outside act-as sessions.
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/logos/${logoId}${withActAsOrgId("")}`,
    );
    const data = await response.json();
    //console.log("Logo:", data);
    return data;
  }

  async function getLogoOptions(): Promise<LogoOptionsDto> {
    const response = await authFetch(`${API_URL}/logos/options/all`);

    return await response.json();
  }

  async function getTransferOptions(vendorId?: number): Promise<TransferDto[]> {
    const vendorIdQueryParameter = vendorId ? `?vendorId=${vendorId}` : "";

    const response = await authFetch(
      `${API_URL}/logos/options/transfersizes${vendorIdQueryParameter}`,
    );
    return await response.json();
  }

  async function deleteLogoById(orgId: number, logoId: number): Promise<void> {
    await authFetch(`${API_URL}/organizations/${orgId}/logos/${logoId}`, {
      method: "DELETE",
    });
  }

  async function deleteDesign(orgId: number, designId: number): Promise<void> {
    await authFetch(`${API_URL}/organizations/${orgId}/designs/${designId}`, {
      method: "DELETE",
    });
  }

  async function getStyleById(id: number): Promise<StyleDto> {
    const response = await authFetch(`${API_URL}/styles/${id}`);
    return await response.json();
  }

  async function deleteStyle(styleId: number): Promise<void> {
    await authFetch(`${API_URL}/styles/${styleId}`, {
      method: "DELETE",
    });
  }

  async function getOriginalMask(
    styleId: number,
    styleViewId: number,
  ): Promise<UrlResponse> {
    const response = await authFetch(
      `${API_URL}/styles/${styleId}/views/${styleViewId}/mask?original=true`,
    );
    return await response.json();
  }

  async function getProfile(orgId?: number): Promise<ProfileResponse> {
    const path = orgId ? `/${orgId}` : "";

    const response = await authFetch(`${API_URL}/profile${path}`);

    return await response.json();
  }

  async function updateProfile(
    profile: UpdateProfileDto,
    orgId?: number,
  ): Promise<ProfileResponse> {
    const body = profile;
    const path = orgId ? `/${orgId}` : "";

    const response = await authFetch(`${API_URL}/profile${path}`, {
      method: "PUT",
      body: JSON.stringify(body),
    });
    return response.json();
  }

  async function updateMask(
    styleId: number,
    styleViewId: number,
    mask: Blob,
  ): Promise<void> {
    const file = new File([mask], "some_file");
    const formData = new FormData();
    formData.append("file", file);

    await authFetch(`${API_URL}/styles/${styleId}/views/${styleViewId}/mask`, {
      method: "PUT",
      body: formData,
    });
  }

  async function uploadCompanyLogo(orgId: number, logo: File): Promise<void> {
    const formData = new FormData();
    formData.append("file", logo);

    await authFetch(`${API_URL}/organizations/${orgId}/logo`, {
      method: "POST",
      body: formData,
    });
  }

  async function deleteCompanyLogo(orgId: number): Promise<void> {
    await authFetch(`${API_URL}/organizations/${orgId}/logo`, {
      method: "DELETE",
    });
  }

  async function uploadProviderLogo(logo: File): Promise<void> {
    const formData = new FormData();
    formData.append("file", logo);

    await authFetch(`${API_URL}/provider/logo`, {
      method: "POST",
      body: formData,
    });
  }

  async function uploadCatalog(
    manufacturerId: string,
    catalog: File,
  ): Promise<void> {
    const formData = new FormData();
    formData.append("File", catalog);

    await authFetch(`${API_URL}/styles/upload/${manufacturerId}`, {
      method: "POST",
      body: formData,
    });
  }

  async function createManufacturer(
    body: CreateManufacturerBody,
  ): Promise<ManufacturerDto> {
    const response = await authFetch(`${API_URL}/manufacturers`, {
      method: "POST",
      body: JSON.stringify(body),
    });

    return response.json();
  }

  async function createUser(body: CreateUserBody): Promise<void> {
    await authFetch(`${API_URL}/users/create`, {
      method: "POST",
      body: JSON.stringify(body),
    });
  }

  async function deleteUser(userId: number): Promise<void> {
    await authFetch(`${API_URL}/users/${userId}`, {
      method: "DELETE",
    });
  }

  // The API only exposes PUT /users (target user id travels in the body);
  // users/{id} exists for GET/DELETE only.
  async function updateUser(body: UpdateUserBody): Promise<void> {
    await authFetch(`${API_URL}/users`, {
      method: "PUT",
      body: JSON.stringify(body),
    });
  }

  async function setUserHidePrices(
    orgId: number,
    userId: number,
    body: SetUserHidePricesBody,
  ): Promise<void> {
    await authFetch(
      `${API_URL}/organizations/${orgId}/users/${userId}/hide-prices`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  }

  // NOTE: the backend (DesignFunctions.ChangeStyle) returns the full updated
  // design as the same DesignDto (same mapper + OrganizationId context) as
  // GetDesign, so the response is typed as the raw DTO and mapped/cached by
  // the repository instead of being thrown away.
  async function changeStyle(
    orgId: number,
    designId: number,
    body: ChangeStyleBody,
  ): Promise<DesignDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/designs/${designId}/style`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );

    return response.json();
  }

  async function changeDesignTitle(
    orgId: number,
    designId: number,
    body: ChangeTitleBody,
  ): Promise<Design> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/designs/${designId}/rename`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );

    return response.json();
  }

  async function getUsersOfOrganization(orgId: number): Promise<User[]> {
    const response = await authFetch(`${API_URL}/users?orgId=${orgId}`, {
      method: "GET",
    });
    return response.json();
  }

  async function getCreateMaskQueueCount(): Promise<CreateMaskQueueCount> {
    const response = await authFetch(`${API_URL}/styles/view/pending`);

    return response.json();
  }

  type QueueCountApiResponse = {
    QueueName?: string;
    queueName?: string;
    Count?: number;
    count?: number;
  };

  function mapQueueCount(
    item?: QueueCountApiResponse | null,
  ): CreateMaskQueueCount | null {
    if (!item) {
      return null;
    }
    const rawName = item.QueueName ?? item.queueName ?? "";
    const rawCount = item.Count ?? item.count ?? 0;
    return {
      queueName: typeof rawName === "string" ? rawName : String(rawName ?? ""),
      count: typeof rawCount === "number" ? rawCount : Number(rawCount) || 0,
    };
  }

  function normalizeQueueCounts(data: unknown): CreateMaskQueueCount[] {
    if (Array.isArray(data)) {
      return data
        .map((item) => mapQueueCount(item as QueueCountApiResponse))
        .filter((item): item is CreateMaskQueueCount => item !== null);
    }
    if (typeof data === "object" && data !== null) {
      const single = mapQueueCount(data as QueueCountApiResponse);
      return single ? [single] : [];
    }
    return [];
  }

  async function getImportLogosQueueCounts(): Promise<CreateMaskQueueCount[]> {
    const response = await authFetch(`${API_URL}/logos/import/pending`);
    const data = await response.json();
    return normalizeQueueCounts(data);
  }

  async function getImportPricesQueueCounts(): Promise<CreateMaskQueueCount[]> {
    const response = await authFetch(`${API_URL}/prices/import/pending`);
    const data = await response.json();
    return normalizeQueueCounts(data);
  }

  async function getImportDesignsQueueCounts(): Promise<
    CreateMaskQueueCount[]
  > {
    const response = await authFetch(`${API_URL}/designs/import/pending`);
    const data = await response.json();
    return normalizeQueueCounts(data);
  }

  async function updateStyle(
    styleId: number,
    body: UpdateStyleBody,
  ): Promise<StyleDto> {
    const response = await authFetch(`${API_URL}/styles/${styleId}`, {
      method: "PUT",
      body: JSON.stringify(body),
    });

    return response.json();
  }

  async function createUserUploadedStyle(
    orgId: number,
    data: {
      brandName: string;
      modelName: string;
      categoryKey: string;
      frontImage: File;
      backImage?: File;
      leftImage?: File;
      rightImage?: File;
      mirrorLeftToRight?: boolean;
      mirrorRightToLeft?: boolean;
      ppcm: number;
    },
  ): Promise<StyleDto> {
    const formData = new FormData();
    formData.append("brandName", data.brandName);
    formData.append("modelName", data.modelName);
    formData.append("categoryKey", data.categoryKey);
    formData.append("frontImage", data.frontImage);
    if (data.backImage) formData.append("backImage", data.backImage);
    if (data.leftImage) formData.append("leftImage", data.leftImage);
    if (data.rightImage) formData.append("rightImage", data.rightImage);
    if (data.mirrorLeftToRight) formData.append("mirrorLeftToRight", "true");
    if (data.mirrorRightToLeft) formData.append("mirrorRightToLeft", "true");
    formData.append("ppcm", data.ppcm.toString());

    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/styles/user-uploaded`,
      {
        method: "POST",
        body: formData,
      },
    );

    return response.json();
  }

  async function getStyleCategories(): Promise<
    { key: string; name: string }[]
  > {
    const response = await authFetch(`${API_URL}/styles/categories`);
    return response.json();
  }

  async function changeColors(
    orgId: Organization["id"],
    logoId: BaseLogo["id"],
    colors: ChangeLogoColors,
  ): Promise<BaseLogo> {
    const body = colors;

    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/logos/${logoId}/changecolors`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
    const data = await response.json();
    // console.log("Change colors data:", data);
    return data;
  }

  async function changeLogoTitle(
    orgId: number,
    logoId: number,
    title: string,
  ): Promise<BaseLogo> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/logos/${logoId}/rename`,
      {
        method: "PUT",
        body: JSON.stringify({ newName: title }),
      },
    );

    return response.json();
  }

  async function placeVerdictLogo(
    logo: BaseLogo,
    verdict: Verdict,
  ): Promise<BaseLogo> {
    const orgId = getLogoOrgId(logo);
    const logoId = logo.id;
    //console.log("Send verdict request for org: " + orgId);
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/logos/${logoId}/approval`,
      {
        method: "PUT",
        body: JSON.stringify(verdict),
      },
    );
    return response.json();
  }

  async function placeVerdictDesign(
    design: Design,
    verdict: Verdict,
  ): Promise<DesignDto> {
    const orgId = design.customer.id;
    const designId = design.id;
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/designs/${designId}/approval`,
      {
        method: "PUT",
        body: JSON.stringify(verdict),
      },
    );
    return response.json();
  }

  async function placeVerdictOrder(
    order: Order,
    verdict: Verdict,
  ): Promise<Order> {
    const orgId = order.organization.id;
    const logoId = order.id;
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/orders/${logoId}/approval`,
      {
        method: "PUT",
        body: JSON.stringify(verdict),
      },
    );
    return response.json();
  }

  async function setPackagingAndDelivery(
    order: Order,
    deliveryType: DeliveryType,
    packaging: Packaging,
  ): Promise<OrderDto> {
    const orgId = order.organization.id;
    const orderId = order.id;
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/orders/${orderId}/packagingAndDelivery`,
      {
        method: "PUT",
        body: JSON.stringify({
          deliveryType: deliveryType.toString(),
          packagingType: packaging.toString(),
        }),
      },
    );
    return response.json();
  }

  async function getDeliveryDatePreview(
    orgId: number,
    productNos: string[],
    deliveryType: string,
  ): Promise<Date> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/orders/delivery-date-preview`,
      {
        method: "POST",
        body: JSON.stringify({
          productNos,
          deliveryType,
        }),
      },
    );

    if (!response.ok) {
      throw new Error("Failed to fetch delivery date");
    }

    const data = await response.json();
    //console.log("Delivery Date Preview API Response:", data);

    let dateStr = data;

    // Handle NAV wrapper object or DTO if present
    if (data && typeof data === "object") {
      if ("return_value" in data) {
        dateStr = data.return_value;
      } else if ("LatestDeliveryDate" in data) {
        dateStr = data.LatestDeliveryDate;
      } else if ("latestDeliveryDate" in data) {
        dateStr = data.latestDeliveryDate;
      }
    }

    const date = new Date(dateStr);
    if (isNaN(date.getTime())) {
      throw new Error(
        `Invalid date received from API. Raw data: ${JSON.stringify(data)}`,
      );
    }

    // Force date to be 12:00:00 to avoid timezone issues when converting to YYYY-MM-DD
    date.setHours(12, 0, 0, 0);

    return date;
  }

  async function getDeliveryAddresses(orgId?: number) {
    if (orgId == null) {
      return [];
    }
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/deliveryAddresses`,
    );
    return response.json();
  }

  async function setDefaultDeliveryAddress(orgId: number, addressId: number) {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/deliveryAddress/${addressId}`,
      { method: "PUT" },
    );
  }

  async function getPublicDesignEntry(key: string) {
    const response = await fetch(`${API_URL}/public/order/entry/${key}`);
    return response.json();
  }

  async function postPublicDesignEntry(key: string, orderline: CartItemDesign) {
    const instances = orderline.instances.map((i) => ({
      label: i.label,
      size: i.size,
      quantity: i.toDelivery,
      values: i.logos
        .filter((l) => l.logoVariant !== "static")
        .map((l) => ({
          logoId: l.logoId,
          value: l.value,
        })),
    }));
    const response = await fetch(`${API_URL}/public/order/entry/${key}`, {
      method: "POST",
      body: JSON.stringify({ instances }),
    });
    return response.ok;
  }

  async function downloadPublicTemplate(
    key: string,
    orderline: CartItemDesign,
  ) {
    const design = orderline.design;
    const body: CreateDesignTemplateDto = {
      designs: [
        {
          designId: Number(design.id), // Ensure designId is a number
          instances: orderline.instances.map((instance, index) => ({
            label: `Design ${index + 1}`,
            size: instance.size ?? "",
            quantity: instance.toDelivery,
            logos: instance.logos
              .filter((l) => l.logoVariant !== "static")
              .map((logo) => ({
                logoId: logo.logoId,
                view: logo.locationIdentifier,
                value: logo.value.toString(),
              })),
          })),
        },
      ],
    };
    const response = await fetch(
      `${API_URL}/public/order/entry/download-template/${key}`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
    return response.blob();
  }

  async function uploadPublicTemplate(key: string, spreadsheet: File) {
    const file = new File([spreadsheet], "some_file");
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(
      `${API_URL}/public/order/entry/upload-design-template/${key}`,
      {
        method: "POST",
        body: formData,
      },
    );

    return response.json();
  }

  async function approveLogoExternal(logo: ImageLogo): Promise<BaseLogo> {
    const logoPublicKey = logo.approval!.publicKey;
    const response = await authFetch(
      `${API_URL}/logos/${logoPublicKey}/approveExternal`,
      {
        method: "PUT",
      },
    );
    return response.json();
  }

  async function rejectLogoExternal(logo: BaseLogo): Promise<BaseLogo> {
    const orgId = getLogoOrgId(logo);
    const logoId = logo.id;
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/logos/${logoId}/rejectExternal`,
      {
        method: "PUT",
      },
    );
    return response.json();
  }

  async function sendApprovalLogo(
    logo: BaseLogo,
    email: string,
  ): Promise<void> {
    const orgId = getLogoOrgId(logo);
    const logoId = logo.id;
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/logos/${logoId}/approval-send`,
      {
        method: "POST",
        body: JSON.stringify({ email }),
      },
    );
    return response.json();
  }

  async function sendApprovalLogoConditional(
    logo: BaseLogo,
    email: string,
  ): Promise<void> {
    const orgId = getLogoOrgId(logo);
    const logoId = logo.id;
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/logos/${logoId}/approval-send-conditional`,
      {
        method: "POST",
        body: JSON.stringify({ email }),
      },
    );
    return response.json();
  }

  async function sendApprovalDesign(
    design: Design,
    email: string,
  ): Promise<Design> {
    const orgId = design.customer.id;
    const designId = design.id;
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/designs/${designId}/approval-send`,
      {
        method: "POST",
        body: JSON.stringify({ email }),
      },
    );
    return response.json();
  }

  async function sendApprovalDesignConditional(
    design: Design,
    email: string,
  ): Promise<Design> {
    const orgId = design.customer.id;
    const designId = design.id;
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/designs/${designId}/approval-send-conditional`,
      {
        method: "POST",
        body: JSON.stringify({ email }),
      },
    );
    return response.json();
  }

  async function generatePublicKeys(
    logoIds?: number[],
    designIds?: number[],
  ): Promise<{ publicKeys: string[] }> {
    const body: any = {};
    if (logoIds) body.logoIds = logoIds;
    if (designIds) body.designIds = designIds;

    const response = await authFetch(`${API_URL}/approval/generate-keys`, {
      method: "POST",
      body: JSON.stringify(body),
    });
    return response.json();
  }

  async function sendMultiApprovalEmail(
    publicKeys: string[],
    type: "logo" | "design",
    email: string,
  ): Promise<void> {
    const response = await authFetch(`${API_URL}/approval/send-email`, {
      method: "POST",
      body: JSON.stringify({ publicKeys, type, email }),
    });

    if (!response.ok) {
      throw new Error(`Failed to send approval email: ${response.status}`);
    }
  }

  async function initiateApprovalLogo(
    logo: BaseLogo,
    approval: InitiateApproval,
  ): Promise<BaseLogo> {
    // FIXME: Should use current user's organization id instead of the selected customer's id
    const orgId = getLogoOrgId(logo);
    const logoId = logo.id;

    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/logos/${logoId}/approval-start`,
      {
        method: "POST",
        body: JSON.stringify(approval),
      },
    );
    return response.json();
  }

  async function initiateApprovalDesign(
    design: Design,
    approval: InitiateApproval,
  ): Promise<DesignDto> {
    // FIXME: Should use current user's organization id instead of the selected customer's id
    const orgId = design.customer.id;
    const designId = design.id;

    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/designs/${designId}/approval-start`,
      {
        method: "POST",
        body: JSON.stringify(approval),
      },
    );
    return response.json();
  }

  async function setCommissionProfile(
    orgId: number,
    commissionProfile: CommissionProfile,
  ): Promise<CommissionProfileDto> {
    const response = await authFetch(
      `${API_URL}/organization/${orgId}/commission`,
      {
        method: "PUT",
        body: JSON.stringify(commissionProfile),
      },
    );
    return response.json();
  }

  async function deleteCommissionProfile(orgId: number): Promise<void> {
    await authFetch(`${API_URL}/organization/${orgId}/commission`, {
      method: "DELETE",
    });
  }

  async function downloadTemplate(
    orgId: number,
    designs: CartItemDesign[],
  ): Promise<Blob> {
    const body: CreateDesignTemplateDto = {
      designs: designs.map((design) => ({
        designId: Number(design.id), // Ensure designId is a number
        instances: design.instances.map((instance, index) => ({
          label: `Design ${index + 1}`,
          size: instance.size ?? "",
          quantity: instance.toDelivery,
          logos: instance.logos.map((logo) => ({
            logoId: logo.logoId,
            view: logo.locationIdentifier,
            value: logo.value.toString(),
          })),
        })),
      })),
    };

    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/orders/download-template`,
      {
        method: "post",
        body: JSON.stringify(body),
      },
    );
    return await response.blob();
  }

  async function uploadDesignTemplate(
    orgId: number,
    spreadsheet: File,
  ): Promise<DesignTemplate> {
    const file = new File([spreadsheet], "some_file");
    const formData = new FormData();
    formData.append("file", file);

    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/orders/upload-design-template`,
      {
        method: "POST",
        body: formData,
      },
    );

    return response.json();
  }

  async function uploadLogoTemplate(
    orgId: number,
    spreadsheet: File,
  ): Promise<LogoTemplate> {
    const file = new File([spreadsheet], "some_file");
    const formData = new FormData();
    formData.append("file", file);

    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/orders/upload-logo-template`,
      {
        method: "POST",
        body: formData,
      },
    );

    return response.json();
  }

  async function reorder(orgId: number, orderId: number): Promise<OrderDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/orders/${orderId}/reorder`,
      {
        method: "POST",
      },
    );

    return response.json();
  }

  async function refreshStorageCount(logoId: number): Promise<string> {
    const response = await authFetch(
      `${API_URL}/logos/${logoId}/refresh-storage-count`,
      {
        method: "POST",
      },
    );

    return response.text();
  }

  async function getLogoStorageCounts(
    logoId: number,
  ): Promise<LogoStorageCountByOrgDto[]> {
    const response = await authFetch(
      `${API_URL}/logos/${logoId}/storage-counts`,
    );
    return response.json();
  }

  async function refreshLogoStorageCountForOrg(
    logoId: number,
    organizationId: number,
  ): Promise<string> {
    const response = await authFetch(
      `${API_URL}/logos/${logoId}/storage-counts/${organizationId}/refresh`,
      {
        method: "POST",
      },
    );
    return response.text();
  }

  async function getExcludedEmailDomains(): Promise<ExcludedEmailDomainDto[]> {
    const response = await authFetch(`${API_URL}/excluded-email-domains`);
    return response.json();
  }

  async function addExcludedEmailDomain(
    body: AddExcludedEmailDomainDto,
  ): Promise<ExcludedEmailDomainDto> {
    const response = await authFetch(`${API_URL}/excluded-email-domains`, {
      method: "POST",
      body: JSON.stringify(body),
    });

    const result = await response.json();

    return result;
  }

  async function deleteExcludedEmailDomain(
    body: DeleteExcludedEmailDomainDto,
  ): Promise<void> {
    await authFetch(`${API_URL}/excluded-email-domains`, {
      method: "DELETE",
      body: JSON.stringify(body),
    });
  }

  async function getOrganizationManufacturerAccess(
    orgId: number,
  ): Promise<OrganizationManufacturerAccessDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/manufacturer-access`,
    );
    return response.json();
  }

  async function updateOrganizationAccessMode(
    orgId: number,
    accessMode: "Blacklist" | "Whitelist",
  ): Promise<void> {
    await authFetch(`${API_URL}/organizations/${orgId}/access-mode`, {
      method: "PUT",
      body: JSON.stringify({
        organizationId: orgId,
        accessMode: accessMode.toLowerCase(),
      }),
    });
  }

  async function updateOrganizationManufacturerAccess(
    orgId: number,
    manufacturerId: number,
    hasAccess: boolean,
  ): Promise<void> {
    await authFetch(`${API_URL}/organizations/${orgId}/manufacturer-access`, {
      method: "POST",
      body: JSON.stringify({
        organizationId: orgId,
        manufacturerId,
        hasAccess,
      }),
    });
  }

  async function updateManufacturerRestricted(
    manufacturerId: number,
    isRestricted: boolean,
  ): Promise<void> {
    await authFetch(
      `${API_URL}/manufacturers/${manufacturerId}/restricted/${isRestricted}`,
      {
        method: "PUT",
      },
    );
  }

  async function searchAdminVendors(
    searchQuery: string,
  ): Promise<OrganizationDto[]> {
    const response = await authFetch(
      `${API_URL}/organizations/vendors/search`,
      {
        method: "POST",
        body: JSON.stringify({
          searchTerm: searchQuery,
          maxResults: 100,
        }),
      },
    );

    return await response.json();
  }

  async function getPlaceOrderQueueItems(
    query: PageQuery,
  ): Promise<PagedResponse<PlaceOrderQueueItemDto>> {
    const response = await authFetch(
      `${API_URL}/order-queue${toQueryParam(query)}`,
    );
    return await response.json();
  }

  async function getPlaceOrderQueueItem(
    id: number,
  ): Promise<PlaceOrderQueueItemDto> {
    const response = await authFetch(
      `${API_URL}/order-queue/${id}`,
    );
    return await response.json();
  }

  async function retryPlaceOrderQueueItem(
    id: number,
  ): Promise<PlaceOrderQueueItemDto> {
    const response = await authFetch(
      `${API_URL}/order-queue/${id}/retry`,
      { method: "POST" },
    );
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || `Retry failed (${response.status})`);
    }
    return await response.json();
  }

  async function getBlockedTransferMethods(): Promise<{
    blockedMethodKeys: string[];
  }> {
    const response = await authFetch(
      `${API_URL}/transfer-methods/blocked`,
    );
    return await response.json();
  }

  // NOTE: no explicit headers here — authFetch shallow-merges init over its own
  // RequestInit, so a custom headers object would REPLACE the Authorization
  // header. The API reads the raw body, so Content-Type is not required.
  async function updateBlockedTransferMethods(
    blockedMethodKeys: string[],
  ): Promise<void> {
    await authFetch(`${API_URL}/transfer-methods/blocked`, {
      method: "PUT",
      body: JSON.stringify({ blockedMethodKeys }),
    });
  }

  async function getStockOrdersConfig(): Promise<StockOrdersConfigDto> {
    const response = await authFetch(`${API_URL}/stock-orders/config`);
    return await response.json();
  }

  // NOTE: no explicit headers here — authFetch shallow-merges init over its own
  // RequestInit, so a custom headers object would REPLACE the Authorization
  // header (same gotcha as updateBlockedTransferMethods above).
  // blockedOrganizationIds is always sent by the current admin screen; the API
  // additionally treats an absent field as "leave the stored list unchanged".
  // Errors: authFetch never returns a non-OK response — it throws a DataError
  // carrying the API's error message (e.g. the 400 "Unknown organization
  // id(s): …" from id validation), which the admin screen shows in its
  // save-failed toast.
  async function updateStockOrdersConfig(
    stockOrdersDisabled: boolean,
    blockedOrganizationIds: number[],
  ): Promise<void> {
    await authFetch(`${API_URL}/stock-orders/config`, {
      method: "PUT",
      body: JSON.stringify({ stockOrdersDisabled, blockedOrganizationIds }),
    });
  }

  async function syncOrderShipmentDates(): Promise<number> {
    const response = await authFetch(
      `${API_URL}/orders/sync-shipment-dates`,
      { method: "POST" },
    );
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || `Sync failed (${response.status})`);
    }
    return await response.json();
  }

  async function validateOldCredentials(
    username: string,
    password: string,
  ): Promise<any> {
    const response = await fetch(`${API_URL}/users/validate-old-credentials`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username: username, password: password }),
    });

    return response.json();
  }

  async function migrateFromOldWebshop(
    username: string,
    password: string,
    firstName: string,
    lastName: string,
    email: string,
    phone: string,
    customerNo: string,
  ): Promise<any> {
    const response = await fetch(`${API_URL}/users/migrate-from-old-webshop`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: username,
        password: password,
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: phone,
        customerNo: customerNo,
      }),
    });

    return response.json();
  }

  async function startYearlyPriceImport(
    body?: StartPriceImportRequestDto,
  ): Promise<StartPriceImportResponseDto> {
    const response = await authFetch(`${API_URL}/price-import/yearly/start`, {
      method: "POST",
      body: body ? JSON.stringify(body) : undefined,
    });
    return response.json();
  }

  async function getYearlyPriceImportStatus(): Promise<PriceImportStatusResponseDto> {
    const response = await authFetch(`${API_URL}/price-import/yearly/status`);
    return response.json();
  }

  async function getYearlyPriceImportHistory(): Promise<PriceImportHistoryResponseDto> {
    const response = await authFetch(`${API_URL}/price-import/yearly/history`);
    return response.json();
  }

  async function cancelYearlyPriceImport(): Promise<CancelPriceImportResponseDto> {
    const response = await authFetch(`${API_URL}/price-import/yearly/cancel`, {
      method: "POST",
    });
    return response.json();
  }

  async function bulkLogoImport(
    serialNumbers: string[],
  ): Promise<BulkLogoImportResponseDto> {
    const response = await authFetch(`${API_URL}/logos/import/bulk`, {
      method: "POST",
      body: JSON.stringify({ serialNumbers } as BulkLogoImportRequestDto),
    });
    return response.json();
  }

  async function bulkLogoOrganizationUpdate(
    serialNumbers: string[],
  ): Promise<BulkLogoImportResponseDto> {
    const response = await authFetch(
      `${API_URL}/logos/organizations/update/bulk`,
      {
        method: "POST",
        body: JSON.stringify({ serialNumbers } as BulkLogoImportRequestDto),
      },
    );
    return response.json();
  }

  async function bulkPriceImport(
    serialNumbers: string[],
  ): Promise<BulkLogoImportResponseDto> {
    const response = await authFetch(`${API_URL}/prices/import/bulk`, {
      method: "POST",
      body: JSON.stringify({ serialNumbers } as BulkLogoImportRequestDto),
    });
    return response.json();
  }

  async function startImportStartupFees(): Promise<{ success: boolean; message: string }> {
    const response = await authFetch(`${API_URL}/price-import/startup-fees/start`, {
      method: "POST",
    });
    return response.json();
  }

  async function startImportHeatingPrices(): Promise<{ success: boolean; message: string }> {
    const response = await authFetch(`${API_URL}/price-import/heating-prices/start`, {
      method: "POST",
    });
    return response.json();
  }

  async function getLogoSerialsForImport(
    filters: LogoSerialsFilterParams,
  ): Promise<LogoSerialsResponseDto> {
    const params = new URLSearchParams();
    if (filters.searchTerm) params.append("searchTerm", filters.searchTerm);
    if (filters.organizationName)
      params.append("organizationName", filters.organizationName);
    if (filters.classification)
      params.append("classification", filters.classification);
    if (filters.customerId)
      params.append("customerId", String(filters.customerId));
    if (filters.method) params.append("method", filters.method);

    const queryString = params.toString();
    const url = `${API_URL}/logos/import/serials${
      queryString ? `?${queryString}` : ""
    }`;
    const response = await authFetch(url);
    return response.json();
  }

  async function getDesignSerialsForImport(
    filters: DesignSerialsFilterParams,
  ): Promise<DesignSerialsResponseDto> {
    const params = new URLSearchParams();
    if (filters.searchTerm) params.append("searchTerm", filters.searchTerm);
    if (filters.organizationName)
      params.append("organizationName", filters.organizationName);
    if (filters.customerId)
      params.append("customerId", String(filters.customerId));

    const queryString = params.toString();
    const url = `${API_URL}/designs/import/serials${
      queryString ? `?${queryString}` : ""
    }`;
    const response = await authFetch(url);
    return response.json();
  }

  async function bulkDesignImport(
    serialNumbers: string[],
  ): Promise<BulkDesignImportResponseDto> {
    const body: BulkDesignImportRequestDto = { serialNumbers };
    const response = await authFetch(`${API_URL}/designs/import/bulk`, {
      method: "POST",
      body: JSON.stringify(body),
    });
    return response.json();
  }

  async function getHeatingAndPackaging(
    orgId: number,
  ): Promise<
    { heatItemNo: string; packingItemNo: string; specific: string }[]
  > {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/navision/heating-packaging`,
    );
    return await response.json();
  }

  async function getNavisionItemPrice(
    orgId: number,
    itemNo: string,
    customerNo?: string,
  ): Promise<any> {
    const queryString = customerNo ? `?customerNo=${customerNo}` : "";
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/navision/items/${itemNo}${queryString}`,
    );
    return await response.json();
  }

  async function getStatisticsOverview(
    from: string,
    to: string,
  ): Promise<StatisticsOverviewDto> {
    const response = await authFetch(
      `${API_URL}/stats/overview?from=${encodeURIComponent(
        from,
      )}&to=${encodeURIComponent(to)}`,
    );
    return await response.json();
  }

  async function getStatisticsTopVendors(
    from: string,
    to: string,
    metric: TopVendorMetric,
    limit: number,
  ): Promise<TopVendorDto[]> {
    const response = await authFetch(
      `${API_URL}/stats/top-vendors?from=${encodeURIComponent(
        from,
      )}&to=${encodeURIComponent(to)}&metric=${metric}&limit=${limit}`,
    );
    return await response.json();
  }

  async function getStatisticsConversion(
    from: string,
    to: string,
  ): Promise<ConversionMetricsDto> {
    const response = await authFetch(
      `${API_URL}/stats/conversion?from=${encodeURIComponent(
        from,
      )}&to=${encodeURIComponent(to)}`,
    );
    return await response.json();
  }

  async function getStatisticsApproval(
    from: string,
    to: string,
  ): Promise<ApprovalMetricsDto> {
    const response = await authFetch(
      `${API_URL}/stats/approval?from=${encodeURIComponent(
        from,
      )}&to=${encodeURIComponent(to)}`,
    );
    return await response.json();
  }

  async function getStatisticsGoogleAnalytics(
    from: string,
    to: string,
    report: GoogleAnalyticsReportType,
  ): Promise<GoogleAnalyticsReportDto> {
    const response = await authFetch(
      `${API_URL}/stats/google-analytics?from=${encodeURIComponent(
        from,
      )}&to=${encodeURIComponent(to)}&report=${report}`,
    );
    return await response.json();
  }

  async function getStatisticsOrdersToday(
    date?: string,
  ): Promise<OrdersTodayDto> {
    // Optional ?date=YYYY-MM-DD (Danish-local day); the backend defaults to today.
    const queryString = date ? `?date=${encodeURIComponent(date)}` : "";
    const response = await authFetch(
      `${API_URL}/stats/orders-today${queryString}`,
    );
    return await response.json();
  }

  async function getBillingOverview(
    query: PageQuery,
    billingVendorOrgId?: number,
  ): Promise<PagedResponse<BillingOverviewDto>> {
    // Same filter/search/paging surface as the admin organization lists.
    // Optional billingVendorOrgId narrows the list to the organizations
    // billed via that one vendor (the drill-down view). Admin-only; throws
    // on non-OK (e.g. 404 while the endpoint isn't live yet) — the
    // repository hook surfaces that as an error state so the screen can show
    // a friendly "not active yet" message.
    const base = toQueryParam(query);
    const filter =
      billingVendorOrgId !== undefined
        ? `${base ? "&" : "?"}billingVendorOrgId=${billingVendorOrgId}`
        : "";
    const response = await authFetch(
      `${API_URL}/organizations/billing-overview${base}${filter}`,
    );
    return await response.json();
  }

  async function getBillingVendorGroups(
    query: PageQuery,
  ): Promise<PagedResponse<BillingVendorGroupDto>> {
    // The grouped/reversed billing view: one row per billing vendor
    // ("mother") with counts of attached organizations. searchTerm searches
    // the vendor's name/NAV number. Same paging surface and 404/500
    // behavior as getBillingOverview.
    const response = await authFetch(
      `${API_URL}/organizations/billing-vendors${toQueryParam(query)}`,
    );
    return await response.json();
  }

  async function getVendorUsers(
    query: PageQuery,
  ): Promise<PagedResponse<VendorUserDto>> {
    // Admin-only vendor-user lookup. The server searches across name/email/
    // vendor, so the caller only forwards the search term. Throws on non-OK
    // (see getBillingOverview) — same friendly empty/error handling.
    const response = await authFetch(
      `${API_URL}/users/vendor-users${toQueryParam(query)}`,
    );
    return await response.json();
  }

  async function getPrepaymentVendors(
    query: PageQuery,
  ): Promise<PagedResponse<PrepaymentVendorDto>> {
    // Same filter/search/paging surface as the admin vendor list.
    const response = await authFetch(
      `${API_URL}/prepayments/vendors${toQueryParam(query)}`,
    );
    return await response.json();
  }

  async function setPrepaymentVendor(
    orgId: number,
    forcePrepayment: boolean,
  ): Promise<PrepaymentVendorDto> {
    const response = await authFetch(
      `${API_URL}/prepayments/vendors/${orgId}`,
      {
        method: "PUT",
        body: JSON.stringify({ forcePrepayment }),
      },
    );
    return await response.json();
  }

  async function getPrepaymentStatus(
    orgId: number,
  ): Promise<PrepaymentStatusDto> {
    // Whether placing an order for this organization requires prepayment.
    // prepaymentRequired is computed fully server-side (incl. the global
    // flag) — the caller trusts the boolean as-is. authFetch throws on
    // non-OK (e.g. 404 while the endpoint isn't live yet); the repository
    // hook swallows that into "not required" so a failing pre-check can
    // never block an order.
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/prepayment-status`,
    );
    return await response.json();
  }

  async function getImportFailures(): Promise<ImportFailureDto[]> {
    // Raw rows of the ImportFailures table, newest failure first. Admin only.
    const response = await authFetch(`${API_URL}/ops/import-failures`);
    return await response.json();
  }

  async function cancelOrder(orgId: number, orderId: number): Promise<void> {
    // Existing soft-cancel endpoint (sets status Cancelled, guarded server-side).
    // Admin auth bypasses the org check, so the health page can cancel any org's order.
    await authFetch(
      `${API_URL}/organizations/${orgId}/orders/${orderId}/cancel`,
      { method: "POST" },
    );
  }

  async function getSystemHealth(): Promise<SystemHealthDto> {
    // Aggregated health snapshot (orders / imports / prices / queues). Admin only.
    const response = await authFetch(`${API_URL}/ops/system-health`);
    return await response.json();
  }

  async function queueLogoImportByItemNo(
    itemNo: string,
  ): Promise<QueueLogoImportResponse> {
    // The endpoint reads the raw body and strips surrounding quotes, so a
    // JSON-encoded string is accepted (and keeps the body unambiguous).
    const response = await authFetch(`${API_URL}/logo-import/queue`, {
      method: "POST",
      body: JSON.stringify(itemNo),
    });
    return await response.json();
  }

  async function queueDesignImportByItemNo(itemNo: string): Promise<void> {
    // Same raw-string body contract as logo-import/queue, but the response is
    // a plain string ("Design import queued for item: X") — nothing to parse;
    // authFetch already throws on non-OK.
    await authFetch(`${API_URL}/design-import/queue`, {
      method: "POST",
      body: JSON.stringify(itemNo),
    });
  }

  // --- Logo sharing (Etape 3 admin UI; API = Etape 2, built in parallel) ---
  // Until the API is deployed every endpoint below answers 404; callers
  // (LogoSharingRepository) treat that as "sharing API not active yet" and the
  // screens render a friendly empty state instead of an error view.

  async function getOrganizationSharing(
    orgId: number,
  ): Promise<OrganizationSharingDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/sharing`,
    );
    return await response.json();
  }

  async function createSharingRelation(
    orgId: number,
    body: CreateSharingRelationBody,
  ): Promise<SharingRelationDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/sharing/relations`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
    return await response.json();
  }

  async function updateSharingRelation(
    relationId: number,
    body: UpdateSharingRelationBody,
  ): Promise<void> {
    await authFetch(`${API_URL}/sharing/relations/${relationId}`, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  }

  async function getSharingRelationSelections(
    relationId: number,
  ): Promise<SharingSelectionsDto> {
    const response = await authFetch(
      `${API_URL}/sharing/relations/${relationId}/selections`,
    );
    return await response.json();
  }

  async function updateSharingRelationSelections(
    relationId: number,
    logoIds: number[],
  ): Promise<void> {
    await authFetch(`${API_URL}/sharing/relations/${relationId}/selections`, {
      method: "PUT",
      body: JSON.stringify({ logoIds }),
    });
  }

  async function getSharingChain(
    orgId: number,
  ): Promise<SharingChainShopDto[]> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/sharing/chain`,
    );
    return await response.json();
  }

  async function updateSharingReceiverSuspension(
    orgId: number,
    receiverOrgId: number,
    suspended: boolean,
  ): Promise<void> {
    await authFetch(
      `${API_URL}/organizations/${orgId}/sharing/receivers/${receiverOrgId}/suspension`,
      {
        method: "PUT",
        body: JSON.stringify({ suspended }),
      },
    );
  }

  async function updateSharingGlobalExclusion(
    orgId: number,
    excluded: boolean,
    categories: string[],
  ): Promise<void> {
    await authFetch(
      `${API_URL}/organizations/${orgId}/sharing/global-exclusion`,
      {
        method: "PUT",
        body: JSON.stringify({ excluded, categories }),
      },
    );
  }

  async function getLogoSharing(logoId: number): Promise<LogoSharingInfoDto> {
    const response = await authFetch(`${API_URL}/logos/${logoId}/sharing`);
    return await response.json();
  }

  return {
    getHeatingAndPackaging,
    getNavisionItemPrice,
    changeColors,
    changeLogoTitle,
    getAllStyles,
    deleteStyle,
    getAllDesigns,
    getAllManufacturers,
    getManufacturer,
    createDesign,
    updateDesign,
    createTextLogo,
    createPlaceholderNameLogo,
    createPlaceholderNumberLogo,
    generateTextLogoPreview,
    generateNumberLogoPreview,
    getAllTextLogos,
    getDesignSnapshot,
    saveDesignSnapshot: saveDesignSnapshot,
    getDesignPriceSummary,
    getOrder: getOrder,
    submitDesign: submitDesign,
    getAllVendors: getAllVendors,
    getAllCustomers: getAllCustomers,
    getAllOrders,
    getPendingOrdersCount,
    getAwaitingPaymentSummary,
    getOrganization,
    getVendor,
    getCustomer,
    getAllLogos,
    exportGlobalLogosCsv,
    getAllLogosForDesign,
    getAllCountries,
    getCbsConfig,
    getLogo,
    getLogoOptions,
    getTransferOptions,
    getLogos,
    deleteLogoById,
    getStyleById,
    getOriginalMask,
    getProfile,
    updateProfile,
    createAndUploadImageLogo,
    createImageLogo,
    uploadFileImageLogo,
    updateMask,
    updateOrganization: updateOrganization,
    createOrganization: createOrganization,
    deleteOrganization: deleteOrganization,
    uploadCompanyLogo,
    deleteCompanyLogo,
    uploadProviderLogo,
    uploadCatalog,
    createManufacturer,
    createUser,
    deleteUser,
    updateUser,
    setUserHidePrices,
    getCreateMaskQueueCount,
    getImportLogosQueueCounts,
    getImportPricesQueueCounts,
    getImportDesignsQueueCounts,
    updateStyle,
    createUserUploadedStyle,
    getStyleCategories,
    changeStyle,
    changeDesignTitle,
    createOrder,
    updateOrder,
    getOrderPrices,
    commitOrder,
    placeOrder,
    summarizeOrder,
    getDesign,
    updateLogo,
    resizeLogo,
    copyLogo,
    copyDesign,
    commitLogo,
    placeVerdictLogo,
    placeVerdictDesign,
    placeVerdictOrder,
    setPackagingAndDelivery,
    getDeliveryAddresses,
    getDeliveryDatePreview,
    setDefaultDeliveryAddress,
    getPublicDesignEntry,
    postPublicDesignEntry,
    downloadPublicTemplate,
    uploadPublicTemplate,
    approveLogoExternal,
    rejectLogoExternal,
    createCustomer,
    updateCustomer,
    deleteCustomer,
    initiateApprovalLogo,
    sendApprovalLogo,
    sendApprovalLogoConditional,
    sendApprovalDesign,
    sendApprovalDesignConditional,
    commitDesign,
    skipApprovalDesign,
    initiateApprovalDesign,
    deleteDesign,
    getUsersOfOrganization,
    setCommissionProfile,
    deleteCommissionProfile,
    downloadTemplate,
    uploadDesignTemplate,
    uploadLogoTemplate,
    reorder,
    refreshStorageCount,
    getLogoStorageCounts,
    refreshLogoStorageCountForOrg,
    generatePublicKeys,
    sendMultiApprovalEmail,
    getExcludedEmailDomains,
    addExcludedEmailDomain,
    deleteExcludedEmailDomain,
    getOrganizationManufacturerAccess,
    updateOrganizationAccessMode,
    updateOrganizationManufacturerAccess,
    updateManufacturerRestricted,
    searchAdminVendors,
    getPlaceOrderQueueItems,
    getPlaceOrderQueueItem,
    retryPlaceOrderQueueItem,
    getBlockedTransferMethods,
    updateBlockedTransferMethods,
    getStockOrdersConfig,
    updateStockOrdersConfig,
    syncOrderShipmentDates,
    validateOldCredentials,
    migrateFromOldWebshop,
    startYearlyPriceImport,
    getYearlyPriceImportStatus,
    getYearlyPriceImportHistory,
    cancelYearlyPriceImport,
    bulkLogoImport,
    bulkLogoOrganizationUpdate,
    bulkPriceImport,
    startImportStartupFees,
    startImportHeatingPrices,
    getLogoSerialsForImport,
    getDesignSerialsForImport,
    bulkDesignImport,
    getDesignPrices,
    assignCustomer,
    assignCustomerToDesign,
    getStatisticsOverview,
    getStatisticsTopVendors,
    getStatisticsConversion,
    getStatisticsApproval,
    getStatisticsGoogleAnalytics,
    getStatisticsOrdersToday,
    getBillingOverview,
    getBillingVendorGroups,
    getVendorUsers,
    getPrepaymentVendors,
    setPrepaymentVendor,
    getPrepaymentStatus,
    getImportFailures,
    getSystemHealth,
    cancelOrder,
    queueLogoImportByItemNo,
    queueDesignImportByItemNo,
    getDesignFolders,
    createDesignFolder,
    updateDesignFolder,
    deleteDesignFolder,
    moveDesignFolder,
    reorderDesignFolders,
    moveDesignsToFolder,
    moveLogosToFolder,
    getWhatsNew,
    getOrganizationSharing,
    createSharingRelation,
    updateSharingRelation,
    getSharingRelationSelections,
    updateSharingRelationSelections,
    getSharingChain,
    updateSharingReceiverSuspension,
    updateSharingGlobalExclusion,
    getLogoSharing,
  };

  async function assignCustomer(
    orgId: number,
    logoId: number,
    customerId: number,
  ): Promise<LogoDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/logos/${logoId}/assign-customer`,
      {
        method: "POST",
        body: JSON.stringify({ customerId }),
      },
    );
    return response.json();
  }

  async function assignCustomerToDesign(
    orgId: number,
    designId: number,
    customerId: number,
  ): Promise<DesignDto> {
    const response = await authFetch(
      `${API_URL}/organizations/${orgId}/designs/${designId}/assign-customer`,
      {
        method: "POST",
        body: JSON.stringify({ customerId }),
      },
    );
    return response.json();
  }

  async function getDesignPrices(designIds: number[]): Promise<DesignDto[]> {
    // Act-as: scope the price fill like the design list itself (#601/#762) —
    // the admin branch's orgId 0 maps per-org fields (number-logo storage
    // counts) against an arbitrary org. Query param on a POST is fine; the
    // API reads actAsOrgId from the query string. No-op outside act-as.
    const response = await authFetch(
      `${API_URL}/organizations/designs/prices${withActAsOrgId("")}`,
      {
        method: "POST",
        body: JSON.stringify(designIds),
      },
    );
    return await response.json();
  }
}
